import { useTranslation } from "react-i18next"

export const useTranslations = (): Translations => {
  const { t } = useTranslation()

  return {
    billingLabel: t("appNavBar.billingLabel", { defaultValue: defaultTranslations.billingLabel }),
    homeLabel: t("appNavBar.homeLabel", { defaultValue: defaultTranslations.homeLabel }),
    notificationsLabel: t("appNavBar.notificationsLabel", { defaultValue: defaultTranslations.notificationsLabel }),
    settingsLabel: t("appNavBar.settingsLabel", { defaultValue: defaultTranslations.settingsLabel }),
    membersLabel: t("appNavBar.membersLabel", { defaultValue: defaultTranslations.membersLabel }),
    projectsLabel: t("appNavBar.projectsLabel", { defaultValue: defaultTranslations.projectsLabel }),
    projectsDashboardLabel: t("appNavBar.projectsDashboardLabel", {
      defaultValue: defaultTranslations.projectsDashboardLabel,
    }),
    customersLabel: t("appNavBar.customersLabel", { defaultValue: defaultTranslations.customersLabel }),
    suppliersLabel: t("appNavBar.suppliersLabel", { defaultValue: defaultTranslations.suppliersLabel }),
    workspacesLabel: t("appNavBar.workspacesLabel", { defaultValue: defaultTranslations.workspacesLabel }),
    todosLabel: t("appNavBar.todosLabel", { defaultValue: defaultTranslations.todosLabel }),
    kanbanLabel: t("appNavBar.kanbanLabel", { defaultValue: defaultTranslations.kanbanLabel }),
    calendarLabel: t("appNavBar.calendarLabel", { defaultValue: defaultTranslations.calendarLabel }),
    tasksLabel: t("appNavBar.tasksLabel", { defaultValue: defaultTranslations.tasksLabel }),
    resourcesLabel: t("appNavBar.resourcesLabel", { defaultValue: defaultTranslations.resourcesLabel }),
    openSidebarTip: t("appNavBar.openSidebarTip", { defaultValue: defaultTranslations.openSidebarTip }),
    closeSidebarTip: t("appNavBar.closeSidebarTip", { defaultValue: defaultTranslations.closeSidebarTip }),
    hourReportsLabel: t("appNavBar.hourReportsLabel", { defaultValue: defaultTranslations.hourReportsLabel }),
    helpLabel: t("appNavBar.helpLabel", { defaultValue: defaultTranslations.helpLabel }),
  }
}

const defaultTranslations = {
  billingLabel: "Billing",
  homeLabel: "Home",
  notificationsLabel: "Invites",
  settingsLabel: "Settings",
  membersLabel: "Members",
  projectsLabel: "Projects",
  projectsDashboardLabel: "Dashboard",
  customersLabel: "Customers",
  suppliersLabel: "Suppliers",
  workspacesLabel: "Workspaces",
  todosLabel: "Todos",
  kanbanLabel: "Kanban",
  calendarLabel: "Calendar",
  tasksLabel: "Tasks",
  resourcesLabel: "Resources",
  openSidebarTip: "Open sidebar",
  closeSidebarTip: "Close sidebar",
  hourReportsLabel: "Hours",
  helpLabel: "Help",
}

export type Translations = typeof defaultTranslations
